import Layout from "@/Shared/Layout";

export function appLayout({ title, hideMenu }) {
  return function (h, child) {
    return h(Layout, { props: { title, hideMenu } }, [child]);
  };
}
